import { GridFilterInputDate } from "@mui/x-data-grid-pro";

// Custom component that renders the date filter input without a placeholder
export function CustomDateFilterInput(props) {
  return (
    <GridFilterInputDate
      { ...props }
      label={ props.value ? props.label : ` ` } // Workaround for placeholder always showing
    />
  );
}
